/**
 * Create an Item seed. This is a typed identity helper that preserves generics.
 * @param item
 */
export function createItem(item) {
    return {
        ...item,
        get _() {
            throw new Error('This is a test only property');
        },
    };
}
/**
 * Create a fallback unknown-content item seed from element data
 * @param el Element with data-bgi attribute
 * @param fallbackName Default name when data-bgi is missing
 */
export function createUnknownContentItem(el, fallbackName = 'unknown-content') {
    return createItem({
        name: el.dataset.bgi ?? fallbackName,
        version: el.dataset.bgiVer ?? '0.0.0',
        template: el.innerHTML ?? '',
        style: '',
        editor: '',
    });
}
